'use strict';

import EventEmitter from 'common/event-emitter';
import * as Constants from './Constants';
import FxoMessenger from './FxoMessenger';

/**
 * Web messenger instance manager.
 * Ensures only a single messenger instances lives on the page.
 */
export default class MessengerManager extends EventEmitter {
  createInstance(containerElement = null) {
    this._containerElement = containerElement;
    // Install itself in the global
    if (this._removeExistingMessenger()) {
      console.warn(
        'FxoMessenger:',
        'Found another instance of FxoMessenger. Removing old instance. Installing new one.'
      );
    }
    const messenger = new FxoMessenger(this.config, containerElement);
    this._messengerInstance = messenger;

    messenger.on(Constants.EVENTS.CLOSED, () => {
      //console.log('Messenger closed itself');
      this._messengerInstance = undefined;
      this.emit(Constants.EVENTS.DESTROYED);
    });

    Constants.LIFECYCLE_EVENTS.forEach((name) => {
      messenger.on(name, (data) => {
        this.emit(name, data);
      });
    });

    this.emit(Constants.EVENTS.CREATED);

    return true;
  }

  destroyCurrent() {
    return !!this._removeExistingMessenger();
  }

  clearCurrent() {
    const messenger = this._messengerInstance;
    if (messenger) {
      messenger._clearHistory();
    }
  }

  forget() {
    const messenger = this._messengerInstance;
    if (messenger) {
      messenger._forget();
    }
  }

  toggleCurrentState() {
    if (!this._removeExistingMessenger()) {
      return this.createInstance(this._containerElement);
    }
    return false;
  }

  // Set config for all future instances too
  setConfig(config) {
    let priorConfig = this.config || {};
    let priorMeta = (this.config && this.config.metadata) || {};
    let newConfig = Object.assign({}, priorConfig, config);
    let newMeta = Object.assign({}, priorMeta, config.metadata);
    newConfig.metadata = newMeta;
    this.config = newConfig;
    const messenger = this._messengerInstance;
    if (messenger) {
      messenger.setConfig(this.config);
    }
  }

  getInstanceState() {
    const messenger = this._messengerInstance;
    return (
      (messenger && messenger.getState()) || {
        state: 'detached',
      }
    );
  }

  sendMessage(text, metadata) {
    const messenger = this._messengerInstance;
    if (!messenger) {
      return false;
    }
    return messenger.sendMessage(text, metadata || {});
  }

  // 'private' methods

  get _messengerInstance() {
    return this._currentFxoMessenger;
  }

  set _messengerInstance(obj) {
    this._currentFxoMessenger = obj;
  }

  _removeExistingMessenger() {
    const messenger = this._messengerInstance;
    if (messenger) {
      messenger.destroy();
      this._messengerInstance = undefined;
      this.emit(Constants.EVENTS.DESTROYED);
    }
    return !!messenger;
  }
}



// WEBPACK FOOTER //
// ./src/messenger/lib/MessengerManager.js